<template>
  <div id="main-box" class="page-content">
    <div class="home-box">

      <!-- <div class="swiper-container home-hint">
        <div class="swiper-wrapper">
          <div class="swiper-slide notice-row" v-for="item in notice" v-text="item"></div>
        </div>
      </div> -->

      <div class="hone-notice-box">
        <div class="hone-notice-row">
          <img src="/static/images/banner-05.jpg" />
        </div>
        <div class="hone-notice-row">
          <div class="swiper-container banner">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in banner" :key="index" @click="OpenPage(item.url)">
                <img :src="`/static/images/${item.img}`" />
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>

        </div>
      </div>

      <div class="nav-box">
        <ul class="nav-main" v-for="(item,index) in navlist" v-on:click="OpenPage('Order',item.id)">
          <li class="nav-main-icon"><i class="fa" :class="item.icon"></i></li>
          <li class="nav-main-right">
            <p v-text="item.name"></p>
            <p v-text="item.count"></p>
          </li>
        </ul>
      </div>
    </div>

    <div class="home-mian">

      <div class="home-mian-left home-mian-row" :style="{height:boxheight+'px'}">
        <div class="home-main-title">账户余额</div>
        <div class="home-main-count" v-text="money"></div>
        <div>
          <div class="home-main-btnArr">
            <a v-on:click="OpenPage('Recharge')">立即充值</a>
            <a v-on:click="OpenPage('ConsumptionRecord')">消费记录</a>
          </div>
        </div>
      </div>
      <div class="home-mian-right">
        <div class="home-mian-row home-mian-right-contact" :style="{height:boxheight+'px'}">
          <div class="home-main-title">联系方式</div>
          <div class="home-mian-right-row home-mian-right-contact-box">
            <ul>
              <li>
                <p>电话：</p>
                <p>15674348663</p>
              </li>
              <li>
                <p>Q Q：</p>
                <p>314659262</p>
              </li>
              <li>
                <p>Q群：</p>
                <p>924554826</p>
              </li>
              <li>
                <p>微信：</p>
                <p>guangyu857857</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="home-mian-row home-mian-right-address" :style="{height:boxheight+'px'}" ref="address">
          <div class="home-main-title">东莞仓地址</div>
          <div class="home-mian-right-row">
            <ul>
              <li>
                <p>收件人：</p>
                <p v-text="name"></p>
              </li>
              <li>
                <p>手　机：</p>
                <p>自己手机（方便商家反馈问题）</p>
              </li>
              <li>
                <p>地　址：</p>
                <p>广东省东莞市常平镇漱新村荣华街22号</p>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="home-mian-row home-mian-right-address" :style="{height:boxheight+'px'}">
          <div class="home-main-title">上海仓地址</div>
          <div class="home-mian-right-row">
            <ul>
              <li>
                <p>收件人：</p>
                <p v-text="name"></p>
              </li>
              <li>
                <p>手　机：</p>
                <p>18611195874</p>
              </li>
              <li>
                <p>地　址：</p>
                <p>上海市静安区余姚路188号</p>
              </li>
            </ul>
          </div>
        </div> -->
      </div>

    </div>

    <div class="chart-box">
      <div class="chart-consume" id="ConsumeChart"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>


  </div>
</template>

<script>
var self,ConsumeChart;
import axios from 'axios'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
export default {
  name: 'HomePage',
  components: {
    'K-Loading': Loading,
    'K-Toast': Toast,
  },
  data () {
    return {
      name:"黑领科技",
      loading: false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      notice:[
        "Exshopee库存功能已上线，操作流程可在教程中查看！",
        "邀请好友注册exshopee并绑定店铺成功后，可获返10积分！",
        "ExShopee上架功能开启，点击上方导航 “上架” 按钮，免费使用吧！",
        "新用户注册可免费获赠5积分！",
        "Exshopee货代已开通上海仓，如果需要使用上海仓可在店铺列表切换！",
      ],
      banner:[{
        img: 'banner-01.jpg',
        url: 'UserHomePage'
      },{
        img: 'banner-03.jpg',
        url: '上架'
      },{
        img: 'banner-02.jpg',
        url: 'Promote'
      }],
      isLogin:true,
      money:0,
      navlist:[{
        id:1,
        count:0,
        icon:"fa-cloud",
        name:"未提交订单"
      },{
        id:2,
        count:0,
        icon:"fa-star",
        name:"已提交订单"
      },{
        id:3,
        count:0,
        icon:"fa-cloud-upload",
        name:"已完成订单"
      },{
        id:4,
        count:0,
        icon:"fa-exclamation-circle",
        name:"异常订单"
      },{
        id:5,
        count:0,
        icon:"fa-hashtag",
        name:"已关闭订单"
      }],
      orders:[],
      boxheight: 210
    }
  },
  mounted () {
    self = this;
    self.SetNavActive("货代",self.$route.name);
    self.GetDatas();
    // self.boxheight = this.$refs.address.offsetHeight;

    if(localStorage.getItem("ExShopee_id")){
      self.name = self.name + localStorage.getItem("ExShopee_id")
    }

    //屏幕宽度改变图表自动适应
    window.addEventListener('resize',function(){
    	self.ChangeChartWidth();
    })

    //滚动公告
    new Swiper('.home-hint', {
    	autoplay: {
        delay: 3000,
      },
    	loop: true,
      direction: 'vertical',
    })

    //滚动公告
    new Swiper('.banner', {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        bulletActiveClass: 'home-bullet-active',
      }
    })

    // if(!localStorage.getItem("ExShopee_notice")){
    //   //系统通知
    //   layui.use(['layer'], function() {
    //   	layer = layui.layer;
    //   	layer.alert('2021年9月20日起，续重运费将从0.5元/kg，调整为1元/kg，感谢您的支持，祝商祺！',{
    //   	  title:"系统通知"
    //   	})
    //   });
    //   localStorage.setItem("ExShopee_notice",true);
    // }

  },
  methods:{
    drawLine(){
        // 基于准备好的dom，初始化echarts实例
        ConsumeChart = self.$echarts.init(document.getElementById('ConsumeChart'))
        var datas = self.orders;
        var numlist = [],datelist = [];
        for(let item in datas){
          numlist.push(datas[item][0])
          datelist.push(datas[item][1])
        }

        let option = {
						title: {
							top: 20,
							left:20,
							text: '订单数量（站点总和）',
							subtext: 'Quantity of order'
						},
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
						grid: {
							top: 90,
              left: 55,
							bottom: 30,
							right: 40,
              borderColor:"#F00"
						},
            xAxis: {
                type: 'category',
                data: datelist,
                axisLine: {
                    show:false,
                    lineStyle: {
                        color: ['rgba(128, 128, 128,0.8)'],
                    }
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: ['rgba(128, 128, 128,0.6)'],
                    }
                }
            },
            series: [{
                data: numlist,
                type: 'line',
                symbolSize:10,
                itemStyle: {
                	color: "#65bdf8",
                  borderWidth:3
                }
            }]
        };

        // 绘制图表
        ConsumeChart.setOption(option);
    },
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    GetDatas () {
      axios({
        method: 'post',
        url: self.GetServerUrl() + "/index_statics/",
        headers: {'token': localStorage.getItem("ExShopee_token")}
      }).then(function(response) {
        self.loading = false;

        //返回数据处理
        self.ReturnFuntion(self,response,function(datas){
          var json = datas;
          var navlist = self.navlist;
          for(let item in navlist){
            navlist[item].count = json.count_arr[item]
          }
          self.money = json.integral;
          self.navlist = navlist;
          self.orders = json.list;
          self.drawLine();
        });

      }).catch(function(error) {
        self.drawLine();
        self.loading = false;
        self.ToastFun(2,error);  //弹窗提醒
      })
    },
    OpenPage (url,data) {

      if(url === "上架"){
        this.$bus.$emit('watchNavSwitch',url);
        return;
      }

      localStorage.setItem("ExShopee_HistoryURL",url);
      if(data){
        self.GoToPage('/'+url+'?te='+data); // 路由跳转
      }else{
        self.GoToPage('/'+url); // 路由跳转
      }
    },
    ChangeChartWidth(){
      ConsumeChart.resize();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-box{
  padding:20px 20px 0 20px;
}
.nav-box{
  overflow: hidden;
}

.nav-main{
  float: left;
  width: calc(18.39% - 40px);
  background-color: #33cabb;
  margin-right: 2%;
  padding:30px 20px;;
  cursor: pointer;
  border-radius: 5px;
}
.nav-main:hover{
  opacity: 0.9;
}
.nav-main:last-child{
  margin-right: 0%;
}
.nav-main-icon{
  display: inline-block;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  color: #FFF;
  float: left;
  text-align: center;
  font-size: 1.5em;
  line-height: 48px;
  background-color: rgba(255, 255, 255, 0.175);
}
.nav-main-icon img{
  display: table;
  width: 100%;
}
.nav-main-left{
  float: left;
}
.nav-main-right{
  float: right;
  color: #FFF;
}
.nav-main-right p:first-child{
  font-size: 14px;
}
.nav-main-right p:last-child{
  font-size: 2em;
  margin-top: 10px;
  text-align: center;
}
.nav-main:nth-child(1){
  background-color: #33cabb;
}
.nav-main:nth-child(2){
  background-color: #65bdf8;
}
.nav-main:nth-child(3){
  background-color: #15c377;
}
.nav-main:nth-child(4){
  background-color: #f96868;
}
.nav-main:nth-child(5){
  background-color: #926dde;
}

.home-mian{
  overflow: hidden;
}
.home-mian-left{
  width: 230px;
  float: left;
  margin: 20px 0 20px 20px;
}
.home-mian-right{
  float: left;
  overflow: hidden;
  width: calc(100% - 290px);
  padding:20px;
}
.home-mian-row{
  border-radius: 5px;
  background-color: #FFF;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
}
.home-main-title{
  font-size:15px;
  color:#666;
  padding:15px 20px;
}
.home-main-count{
  text-align: center;
  font-size:2em;
  margin:30px 0;
  color:#f60;
}
.home-main-btnArr{
  overflow: hidden;
  display: table;
  margin:0 auto;
  margin-bottom: 20px;

}
.home-main-btnArr a{
  float: left;
  display: table;
  padding:10px 15px;
  margin-right: 10px;
  border-radius: 5px;
  border:1px solid #EEE;
  cursor: pointer;
}
.home-main-btnArr a:hover{
  color:#000;
  background-color: #F9F9F9;
}

.home-mian-right-contact{
  float: left;
  width: 50%;
  margin-right: 20px;
}
.home-mian-right-address{
  float: left;
  width: calc(50% - 20px);
  margin-right: 20px;
}
.home-mian-right-address:last-child{
  margin-right: 0;
}
.home-mian-right-row{
  padding:0 25px;
  padding-bottom: 20px;
  border-top:1px solid #f3f3f3;
}
.home-mian-right-row ul li{
  overflow: hidden;
}
.home-mian-right-row ul li p{
  float: left;
  margin-top: 11px;
  font-size:15px;
  line-height: 22px;
  color:#333;
}
.home-mian-right-row ul li p:first-child{
  width: 70px;
}
.home-mian-right-row ul li p:last-child{
  width: calc(100% - 70px);
}
.home-mian-right-row a{
  display: table;
  padding:1px 3px;
  border-radius: 50px;
  color:#fff;
  background:rgba(101,189,248,0.8)
}
.home-mian-right-contact-box  ul li p:first-child{
  width: 53px;
}

.chart-box{
  position: relative;
  padding:0 20px 20px 20px;
}
.chart-consume{
  width: 100%;
  height: 350px;
  border-radius: 5px;
  background-color: #FFF;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
}

.hone-notice-box{
  display: flex;
  margin-bottom:20px;
  justify-content: space-between;
}
.hone-notice-row{
  width: 50%;
}
.hone-notice-row:first-child{
  margin-right: 20px;
}
.hone-notice-row img{
  display: block;
  width: 100%;
  height: 100%;
}
.banner .swiper-slide{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/logistics/HomePage.vue